// extracted by mini-css-extract-plugin
module.exports = {"form":"Search_form__1pRkM","slide-down":"Search_slide-down__3Wha6","close":"Search_close__R64pa"};